import { render, staticRenderFns } from "./TgMemberBatchDialog.vue?vue&type=template&id=ccb79e18"
import script from "./TgMemberBatchDialog.vue?vue&type=script&lang=js"
export * from "./TgMemberBatchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports